import SectionHeader from '@/components/base/SectionHeader';
import AnimeCard from '@/components/base/AnimeCard';
import { getNewAnime } from '@/mocks/anime';

export default function LatestAnime() {
  const newAnime = getNewAnime().slice(0, 6);

  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <SectionHeader
          title="最近更新"
          subtitle="最新上线的热门番剧，第一时间追番"
          linkTo="/categories"
          linkLabel="查看更多"
        />
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {newAnime.map((anime) => (
            <AnimeCard key={anime.id} anime={anime} />
          ))}
        </div>
      </div>
    </section>
  );
}